export function getTreeItems(object) {
  function recursiveFx(object) {
    let item = {
      id: object.part_group_id,
      label: object.name, // treeselect
      name: object.name // v-tree-view
    }
    
    if ('sub_groups' in object) {
      const children =object.sub_groups.map(c => recursiveFx(c))

      if (children.length > 0) {
        item['children'] = children
      }
    }
    
    return item
  }

  const values = object.map(e => recursiveFx(e))
 
  return values
}